import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import CaretUpIcon from '@offerzen/zenicon/CaretUpIcon'
import CaretDownIcon from '@offerzen/zenicon/CaretDownIcon'
import { colors } from '../../themes'
import { specialKeyPressed } from '../../helpers/eventHelpers'
import Card from '../Card'
import AccessibleIcon from '../AccessibleIcon'
import Subheading from '../../typography/Subheading'
import styles from './styles'

class Collapsible extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    openState: this.props.open,
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.setState({ openState: this.props.open })
    }
  }

  toggleCollapsible = () => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const newOpenState = !this.state.openState

    this.setState({ openState: newOpenState })

    if (this.props.onToggle) {
      this.props.onToggle(newOpenState)
    }
  }

  render() {
    const { openState } = this.state
    const { children, ...props } = this.props

    return (
      <Card theme="light" className={cx(styles.wrapper, props.className)}>
        <button
          type="button"
          className={styles.toggle}
          tabIndex="0"
          onClick={this.toggleCollapsible}
          onKeyDown={ev => {
            if (ev.key === 13 && !specialKeyPressed(ev)) {
              this.toggleCollapsible()
            }
          }}>
          {typeof props.toggle === 'string' ? <Subheading>{props.toggle}</Subheading> : props.toggle}

          <div className={styles.icon}>
            <AccessibleIcon icon={openState ? CaretUpIcon : CaretDownIcon} size={16} color={colors.grayChateau} />
          </div>
        </button>
        {Boolean(openState) && <div className={styles.body}>{children}</div>}
      </Card>
    )
  }
}

Collapsible.propTypes = {
  toggle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  open: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onToggle: PropTypes.func,
}

Collapsible.defaultProps = {
  open: true,
}

export default Collapsible
